import { useCabinetMemberMe } from '@/hooks/useCabinetMemberMe';

/**
 * Vrai si le membre courant a le drapeau `beta_onboarding_tour`
 * (`cabinet_members.feature_flags.beta_onboarding_tour === true`).
 *
 * Le drapeau ne conditionne pas l'existence du parcours : il FORCE le
 * démarrage d'office sur un compte créé avant la date de lancement, pour les
 * démos et les tests internes (cf. `shouldAutoStartTour`).
 */
export function useOnboardingTourFlag(): boolean {
  const { data } = useCabinetMemberMe();
  return data?.feature_flags?.['beta_onboarding_tour'] === true;
}
